<template>
<div
    style="margin-bottom: 15px"
>

    <div
        style="color: rgba(0,0,0,0.6); font-size: 13px;"
    >
        {{label}}
    </div>
    
    <div
        style="display: flex; flex-direction: row; width: 100%"
    >
        <div
            style="flex-grow: 1"
        >
            <div
                style="border-bottom: 1px solid rgb(148,148,148); padding-bottom: 5px;"
            >
            <m-rc-tag-display
                :value="value.values"
                style="margin-top: -10px; margin-bottom: -10px"
                :separator="value.type"
            />
            </div>
        </div>
        <div
            style="flex-grow: 0; margin-left: 15px;"
        >
            <v-icon
                color="primary"
                style="margin-top: 5px"
                v-on:click="onClickEdit"
            >
                mdi-lead-pencil
            </v-icon>
        </div>
    </div>

    <m-edit-tag-filter-dialog
        ref="edit-dialog"
    />

</div>
</template>

<script>
export default {

    props: {
        value: {
            type: Object,
            default: function() { return []; }
        },

        label: {
            type: String,
            default: function() { return 'Tags'; }
        },

        organization_id: {
            type: String,
            default: function() { return this.$rc.$state.getOrganizationId(); }
        },

        applies_to: {
            type: String,
            default: function() { return 'bulk-message'; }
        },

        show_archived: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        onClickEdit() {
            this.$refs['edit-dialog'].showDialog(
                {
                    'organization_id': this.organization_id, 
                    'applies_to': this.applies_to,
                    'filter': this.value,
                    'show_archived': this.show_archived,
                    'on_save': (new_filter) => {
                        this.$emit('input', new_filter);
                    }
                }
            );
        }
    },
}
</script>

<style lang="scss" scoped>

</style>